import Const from "../js/const";

export function deviceSpaceFilter(val, to = 'key') {
    const MAP = Const.DEVICE.SPACE_MAP
    const ITEM = MAP[val + ''] || { key: "c.unknown" }
    return ITEM[to] || ''
}

export function eventTypeFilter(val, to = 'key') {
    const MAP = Const.EVENT.TYPE_MAP
    const ITEM = MAP[val + ''] || { key: "c.unknown" }
    return ITEM[to] || ''
}

export function commandStatusFilter(item, to = 'key') {
    let val = item.status;
    let requestId = item.request_id;

    if (!Number.isInteger(val) || requestId === '') {
        return '-'
    }

    const MAP = Const.COMMAND.STATUS_MAP
    const ITEM = MAP[val + ''] || { key: "c.unknown" }
    return ITEM[to] || ''
}

export function commandTypeFilter(val) {
    if (!Number.isInteger(val)) { return '-' }
    const MAP = Const.COMMAND.TYPE_MAP
    const ITEM = MAP[parseInt(val)]
    return ITEM['key'] || 'c.unknown'
}

export function deviceStatusFilter(device = {}, to = 'key') {
    let status = 0
    if (device) {
        if (device.hasOwnProperty('status')) {
            status = device.status
        } else if (device.last_active_time) {
            let lastActiveTime = parseInt(device.last_active_time);
            let now = new Date().getTime() / 1000;
            if (now - lastActiveTime < 120) {
                status = 1
            }
        }
    }
    const MAP = Const.DEVICE.STATUS_MAP
    const ITEM = MAP[status + ''] || { key: "device.status.offline"  }
    return ITEM[to] || ''
}

// 推送记录耗时
export function relayLogExecutionTime(log) {
    if (!Number.isInteger(log.request_time) || !Number.isInteger(log.response_time)) {
        return '-';
    }
    let requestTime = parseInt(log.request_time);
    let responseTime = parseInt(log.response_time);
    let executionTime = responseTime - requestTime;
    if (executionTime < 0) {
        return '-';
    }

    return executionTime + 'ms';
}
// 推送记录类型
export function requestDataType(log, to = 'key') {
    let type = '';
    try {
        let data = JSON.parse(log.request_data);
        type = data.type;
    } catch (e) {}

    const MAP = Const.REQUEST.DATA_TYPE_MAP
    const ITEM = MAP[type] || { key: "c.unknown" }
    return ITEM[to] || type
}